import React, {useEffect, useState} from 'react'
import {zeroTimer} from '../../helpers/zeroTimer'
import * as cl from './CountDownTimer.module.scss'

const CountDownTimer = ({date, styles}) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(date) - +new Date(new Date().toLocaleString("en-US", {timeZone: "America/Chicago"})).getTime();
    let timeLeft;

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = false
      timeLeft = zeroTimer
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      const calcTime = calculateTimeLeft()
      if (!calcTime) return;
      setTimeLeft(calcTime);
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];
  Object.keys(timeLeft).forEach((interval) => {
    timerComponents.push(
      <div key={interval} className={cl.date}>
        <h4 className={cl.interval}>{interval}</h4>
        <span className={cl.timeLeft}>{(timeLeft[interval] < 10 ? '0' : '') + timeLeft[interval]}</span>
      </div>
    );
  });

  return (
    <div className={cl.timer} style={styles}>
      {timerComponents}
    </div>
  );
};

export default CountDownTimer;